module.exports = __webpack_public_path__ + "static/media/cover_page_t3.3d00f79a.png";